$.fn.CoupDeCoeur = function() {
  let self = this

  if (self.data('coup-de-coeur')) {
    return self.data('coup-de-coeur')
  }

  self.button = self.find('.card-coup-de-coeur__play-btn')
  self.type = self.button.hasClass('card-coup-de-coeur__play-btn--video') ? 'video' : 'image';
  self.video = self.find('.card-coup-de-coeur__video')
  self.resize_timeout = undefined

  self.button_clicked = function() {
    self.toggleClass('card-coup-de-coeur--media-visible')

    if (self.video.length) {
      requestAnimationFrame(function() {
        if (self.hasClass('card-coup-de-coeur--media-visible')) {
          self.video.find('video').get(0).play()
          self.video.find('video').prop('muted', false)
          self.video.find('video').on('click', function() {
            if ($(this).get(0).paused) {
              $(this).get(0).play()
            } else {
              $(this).get(0).pause()
            }
          })
        } else {
          self.video.find('video').off('click')
          self.video.find('video').get(0).pause()
        }
      })
    }
  }

  self.initialize_video = function() {
    if (self.video.length) {
      self.video.VideoLoop()
      self.video.find('video').get(0).pause()
    }
  }

  self.resize_card = function() {
    clearTimeout(self.resize_timeout)
    self.resize_timeout = setTimeout(function() {
      self.find('.card-coup-de-coeur__title').css({
        'font-size': '',
        'height': '',
      })
      let fontSize = self.find('.card-coup-de-coeur__content').width() * ($.mlmi.mobile.isMobile ? .1 : .1125),
      titleHeight = self.find('.card-coup-de-coeur__content').width() * 1.2
      self.find('.card-coup-de-coeur__title').css({
        'font-size': fontSize + 'px',
        'height': titleHeight + 'px',
      })
    }, 100)
  }

  return function() {
    self.button.on('click', self.button_clicked)
    self.initialize_video()
    self.data('coup-de-coeur', self)
    $(window).on('resize load orientationchange', self.resize_card)
    self.resize_card()
    return self
  }()
}
